import { execAdmin } from '@src/apis/reware/utils';
import type {
  DeletePricingRuleMutation,
  DeletePricingRuleMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

export const deletePricingRule = async ({
  partnerId,
  ruleId,
}: DeletePricingRuleMutationVariables) => {
  const query = gql`
    mutation deletePricingRule(
      $partnerId: Int!
      $ruleId: Int!
    ) {
      partner(id: $partnerId) {
        deletePricingRule(ruleId: $ruleId) {
          success
        }
      }
    }
  `;

  const data = await execAdmin<DeletePricingRuleMutationVariables, DeletePricingRuleMutation>(
    query,
    { variables: { partnerId, ruleId } }
  );

  const result = data.partner?.deletePricingRule;
  if (!result) {
    throw new Error(
      `deletePricingRule: unexpected response — partner.deletePricingRule is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId})`
    );
  }
  return result;
};
